/**
 * Цель промысла судна по реестрам РФМО — строкой для карточки.
 *
 * Из всего реестра карточка показывала ОДНО поле — тип судна. У LEDA777 (MMSI
 * 273210650, ООО «САЙРА») комиссия корпус не классифицировала вовсе — «Other
 * fishing vessels [FISHING VESSELS NOT SPECIFIED] (FX)», единственная такая
 * строка под флагом РФ, — и карточка выглядела пустой при заполненном реестре:
 * орудие там названо прямо, а разрешение выписано на сайру.
 *
 * Имена видов приходят ОБОИМИ языками (`rfmo_target_ru` / `rfmo_target_en`):
 * это ДАННЫЕ, их правит админка, и словаря ASFIS у витрины нет. Общее правило
 * «сервер отдаёт код, а не текст» имена видов исключает явно — см. CLAUDE.md.
 *
 * Функция чистая: свойства фичи GeoJSON приходят как `unknown`, читаем их мягко.
 */

/** Массив непустых строк из свойства фичи; всё прочее — пусто. */
function names(value: unknown): string[] {
  if (!Array.isArray(value)) return []
  return value.filter((v): v is string => typeof v === 'string' && v.trim() !== '')
}

/**
 * Перечень целей промысла на языке кабинета, либо `null` — целей нет.
 *
 * `null`, а не прочерк: реестры покрывают флот открытого моря, и целей нет у
 * подавляющего большинства из 95 тысяч судов эфира. Строка с вечным прочерком
 * на каждой карточке была бы шумом — её просто не рисуем.
 *
 * Если на выбранном языке пусто, а на втором нет — показываем второй. Сервер
 * подставляет вместо ненайденного имени сам код ASFIS, так что расходиться
 * массивы не должны; но код лучше прочерка, если это всё же случилось.
 */
export function rfmoTargetLabel(props: Record<string, unknown>, lang: string): string | null {
  const ru = names(props.rfmo_target_ru)
  const en = names(props.rfmo_target_en)
  const preferred = lang === 'en' ? en : ru
  const list = preferred.length > 0 ? preferred : lang === 'en' ? ru : en
  return list.length > 0 ? list.join(', ') : null
}

/**
 * Реестры, в которых судно значится, — строкой; либо `null`, если ни в одном.
 *
 * Коды (`NPFC`, `NEAFC`) не переводятся: это имена организаций, а не подписи.
 * Показывать их обязательно, потому что имя вида океана не называет — «Сельдь
 * атлантическая» и «Сельдь» стоят в одном словаре соседними строками, и
 * различает их только реестр, выписавший разрешение.
 */
export function rfmoOrgsLabel(props: Record<string, unknown>): string | null {
  const orgs = names(props.rfmo_orgs)
  return orgs.length > 0 ? orgs.join(', ') : null
}
